import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useOrderSubmissionData, useServiceablitityData, useSessionData } from '../../hooks/order';
import { routesConfig, WHI_TFN } from '../../util/util';
import { resetState, setTFN } from '../../store/action/OrderAction';

import useLeadsSDK from '../../hooks/useLeadsSDK';
import { Thankyou } from '../../images';

const ThankYou = () => {
  const { t } = useTranslation();
  const leads = useLeadsSDK();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderSubmitResponse } = useOrderSubmissionData();
  const { confirmationNo } = orderSubmitResponse;
  const { orderInfo } = useSessionData();
  const { email, } = orderInfo;
  const { serviceabilityCheck } = useServiceablitityData();
  const { plans = [], mobileProducts = [], fixedWirelessProducts = [] } = serviceabilityCheck;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!plans.length && !mobileProducts.length && fixedWirelessProducts.length) {
      dispatch(setTFN(WHI_TFN));
    } else {
      dispatch(setTFN('thanks'));
    }
    if (isEmpty(orderSubmitResponse)) {
      navigate(routesConfig.home)
    } else {
      dispatch(resetState);
      leads?.reset?.();
    }
  }, []);



  return (
    <div className="elink-container p-top-5 height-big-screen">
      <div className="result-heading-thankyou  result-heading text-center">
        <h1>{t('thankYou.title')}</h1>
        <img src={Thankyou} alt="success" className="" />
        <div className="thankyou-wrapper">
          <span className="order-number">{t('thankYou.orderNumber')} <span className="confirm-number">{confirmationNo}</span></span>

          <p>{t('thankYou.message')} <b className="email-addr">{email}</b>.</p>
        </div>
      </div>

    </div>
  )
}
export default ThankYou;
